import styled from "@emotion/styled";
import Intro from "./Intro";
import { StickyContainer } from "../SharedUI";
import { useRef } from "react";
import { useContainerDimensions } from "../../hooks/useContainerDimensions";

const IntroStickyContainer = styled(StickyContainer)`
  flex-direction: column;
  gap: 4em;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-grow: 1;
`;

interface VisualizationProps {
  currentStep:
    | ""
    | "init"
    | "problem-1-header"
    | "intro"
    | "country-A-pov"
    | "country-B-pov"
    | "discrepancy"
    | "discrepancy2"
    | "toggle"
    | "scale";
  width: number;
  height: number;
}

export default function IntroVisualization({
  currentStep,
}: VisualizationProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { width, height } = useContainerDimensions(containerRef);

  const size = width < 600 ? "narrow" : "wide";

  return (
    <IntroStickyContainer ref={containerRef}>
      <Intro currentStep={currentStep} size={size} height={height} />
    </IntroStickyContainer>
  );
}
